import { BrowserRouter, Routes, Route } from "react-router-dom";

import MainLayout from "./layout/MainLayout";
import VisionForm from "./pages/VisionForm";
import PreviewPage from "./pages/PreviewPage";
import DomainGenerator from "./pages/DomainGenerator";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { StrictMode } from "react";

export default function App() {
  return (
    <StrictMode>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/sitegeneration" element={<VisionForm />} />
            <Route path="/" element={<VisionForm />} />
          </Route>
          <Route path="/sitegeneration/preview" element={<PreviewPage />} />
          <Route path="/sitegeneration/generate/:domain" element={<DomainGenerator />} />
          <Route path="/sitegeneration/generate" element={<DomainGenerator />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </StrictMode>
  );
}
